/**
 * Authentication validators
 */
import { z } from 'zod';
import { isValidPostalCode } from './location.js';
export const emailSchema = z.string().email('Invalid email address').toLowerCase();
export const passwordSchema = z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
    .regex(/[0-9]/, 'Password must contain at least one number')
    .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character');
export const registerSchema = z.object({
    email: emailSchema,
    password: passwordSchema,
    studio_name: z.string().min(2, 'Studio name must be at least 2 characters').max(100),
    first_name: z.string().min(1, 'First name is required').max(50),
    last_name: z.string().min(1, 'Last name is required').max(50),
    phone: z.string().optional(),
    address_line_1: z.string().min(1, 'Address is required').max(200),
    address_line_2: z.string().max(200).optional(),
    city: z.string().min(1, 'City is required').max(100),
    state: z.string().length(2, 'State must be 2-letter code'),
    zip: z.string().refine(isValidPostalCode, 'Invalid ZIP or postal code'),
    // Google Places locality place_id — set only when the city was picked from the
    // autocomplete (NOT from the studio/establishment search, whose id is the
    // studio's, not the city's). Used to resolve a canonical city; never stored on studios.
    google_place_id: z.string().min(1).max(255).optional(),
    // SMS/text-message consent (A2P/10DLC). Optional opt-in checkbox; defaults false.
    sms_consent: z.boolean().optional().default(false),
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Password is required'),
});
export const forgotPasswordSchema = z.object({
    email: emailSchema,
});
export const resetPasswordSchema = z.object({
    token: z.string().min(1, 'Reset token is required'),
    password: passwordSchema,
    password_confirm: z.string(),
}).refine((data) => data.password === data.password_confirm, {
    message: 'Passwords do not match',
    path: ['password_confirm'],
});
//# sourceMappingURL=auth.js.map